// extracted by mini-css-extract-plugin
export var active = "_7z-a";
export var activeIndicator = "_7z-9";
export var disabled = "_7z-b";
export var fullWidth = "_7z-2";
export var lg = "_7z-7";
export var md = "_7z-6";
export var redoButtonTabGroup = "_7z-0";
export var sm = "_7z-5";
export var tabButton = "_7z-4";
export var tabButtonsContainer = "_7z-1";
export var themeDestructive = "_7z-d";
export var themeNormal = "_7z-c";
export var themeSuccess = "_7z-e";
export var xl = "_7z-8";
export var xs = "_7z-3";